import React, { Component } from "react";
import InteractiveMap from "./interactive/interactivemap";
import LocationMap from "./locationmap";
// import Button from "react-bootstrap-button-loader";
import { Button } from "react-bootstrap";
import InfoTutorial from "InfoTutorial";
import LocaleStrings from "Languages";

class MapsHeaderButtons extends Component {
  render() {
    return (
      <ul className="header-buttons content-map-header">
        <li>
          {/* <input className="form-control mapsearch" placeholder="Search" type="text" /> */}
        </li>
        <li>
          <div className="dropdown">
            <Button className="btn btn-custom-blue">
              {/* <i className="fa fa-plus i-custom-m" aria-hidden="true"/> Add New */}
              <img
                style={{ paddingRight: 10, paddingBottom: 3 }}
                src="../../style/images/header-icons/plus.png"
              ></img>
              {LocaleStrings.maps_addnew}
            </Button>
            <div className="dropdown-content">
              <InteractiveMap history={this.props.history} />
              <LocationMap history={this.props.history} />
            </div>
          </div>
        </li>
        <li>
          <InfoTutorial video="map.mp4" />
        </li>
      </ul>
    );
  }
}

export default MapsHeaderButtons;
